// authService.js
import { get, post, del, put } from "../app-core/http-services";
import { toast } from "react-toastify";


const UserSettingsAPISvc = {
  getAllUserSettings: async (currentPage,search) => {
    try {
      // const response = await get(`/organization/allUsers?page=${currentPage}`);
      let apiUrl = "";
      if(search === ""){
        apiUrl = `/organization/allUsers?page=${currentPage}`
      } else {
        apiUrl = `/organization/allUsers?page=1&search=${search}`
      }
      const response = await get(apiUrl);
      return response; 
    } catch (error) {
      throw error;
    }
  },

  createUserSettings: async ({ values, resetValues }) => {
    try {
      const response = await post("/organization/admin/addNewUser", values);

      if (response.statusCode === 200) {
        toast.success(response.message);
        resetValues();
      } else {
        toast.error("An unexpected error occurred during signup.");
      }
      return response;
    } catch (error) {
 
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred during signup.");
      }
      throw error;
    }
  },

  deleteUserSettings: async ({ selectedUsers }) => {
    try {
      const response = await del("/organization/admin/removeUsers", {
        data: {
          selectedUsers: selectedUsers,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  handleUpdateSettings: async ({formattedReq}) => {
    try {
        const response = await put("/organization/admin/updateSingleUser",formattedReq);
        return response;
    } catch (error) {
      throw error;
    }
  },

  bulkRejectStatusSettings: async ({ selectedUsers }) => {
    try {
      const response = await put("/organization/admin/updateUserStatus", {
        selectedUsers,
        isApproved: false,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  bulkApproveStatusSettings: async ({ selectedUsers }) => {
    try {
      const response = await put("/organization/admin/updateUserStatus", {
        selectedUsers,
        isApproved: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  handlePasswordReset: async (body) => {
    console.log("body", body)
    try {
      const response = await post('/user/resetPassword', body);

      console.log("password reset Response", response)
      return response;
    } catch (error) {
      console.error("Error in handlePasswordReset:", error); 
      throw error;
    }
  }
};

export default UserSettingsAPISvc;
